export var warn = function warn(msg) {
  if (typeof console !== 'undefined' && window.__PANDA.logLevel >= 2) {
    console.warn("[panda-log] Warn: " + msg);
  }
};
export var error = function error(msg) {
  if (typeof console !== 'undefined' && window.__PANDA.logLevel >= 1) {
    console.error("[panda-log] Error: " + msg);
  }
};
export var debugInfo = function debugInfo(msg) {
  if (typeof console !== 'undefined' && window.__PANDA.debug) {
    console.error("[panda-log] Debug: " + msg);
  }
};
export var debugError = function debugError(msg) {
  if (typeof console !== 'undefined' && window.__PANDA.debug) {
    console.error("[panda-log] Error:", msg);
  }
};
export var debugFunction = function debugFunction(fn) {
  if (window.__PANDA.debug) {
    fn && fn();
  }
};